import { THEME_STORAGE_KEY } from "./ThemeProvider";

/**
 * Inline script injected into <head> that runs before React hydration.
 * Reads the saved theme from localStorage (or falls back to
 * prefers-color-scheme) and applies the matching class to <html>, so the
 * page paints with the correct theme on first frame and there is no
 * flash-of-unstyled-content.
 *
 * Kept as a string + dangerouslySetInnerHTML so Next.js inlines it before
 * the React tree mounts.
 */
export function ThemeScript() {
  const code = `
(function () {
  try {
    var key = ${JSON.stringify(THEME_STORAGE_KEY)};
    var stored = null;
    try { stored = localStorage.getItem(key); } catch (e) {}
    var theme = stored === 'light' || stored === 'dark' || stored === 'system'
      ? stored
      : 'system';
    var resolved = theme;
    if (theme === 'system') {
      resolved = window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
    }
    var root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(resolved);
    root.style.colorScheme = resolved;
  } catch (e) {
    // Fail silently — page will still render in default light theme.
  }
})();
`;
  return (
    <script
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: code }}
      suppressHydrationWarning
    />
  );
}
